import { AvailabilityEnum } from '../modules/products/ProductTypes';
import { isPreOrder } from '../modules/products/utils/availability.utils';
import { AllowChangeGrid } from '../services/modules/product-colors-packs/product-colors-packs.types';

interface ShouldDisableGridByProductColorGridFlagParams {
  availability: AvailabilityEnum;
  allowChangeImmediateGrid: AllowChangeGrid;
  allowChangePreOrderGrid: AllowChangeGrid;
}

export const shouldDisableGridByProductColorGridFlag = ({
  availability,
  allowChangeImmediateGrid,
  allowChangePreOrderGrid,
}: ShouldDisableGridByProductColorGridFlagParams) => {
  if (availability === AvailabilityEnum.READY_FOR_DELIVERY) {
    return allowChangeImmediateGrid === AllowChangeGrid.DISALLOW;
  } else if (isPreOrder(availability)) {
    return allowChangePreOrderGrid === AllowChangeGrid.DISALLOW;
  }

  return (
    allowChangeImmediateGrid === AllowChangeGrid.DISALLOW ||
    allowChangePreOrderGrid === AllowChangeGrid.DISALLOW
  );
};
